import React, { useEffect, useState } from 'react';
import Logo from "../assets/login-avator.jpg";
import authStorage from '../../utilities/Storage';
import ProfileAvatar from "../../components/assets/profile.jpg";
import axios from 'axios';
import { useNavigate, useLocation } from 'react-router-dom';

const ProductAuthAdd = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [email, setEmail] = useState(null);
    const [company_name, setCompany_Name] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [errors, setErrors] = useState({});
    const [successMessage, setSuccessMessage] = useState('');
    const [products, setProducts] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [loadingProducts, setLoadingProducts] = useState(false);
    const [productError, setProductError] = useState(null);
    
    const [formData, setFormData] = useState({
        product_name: "",
        selling_price: "",
        product_description: ""
    });

    function getUserRegistrationDetails() {
        const userData = authStorage.getUser();
        if (!userData) return;
        
        try {
            const user = JSON.parse(userData);
            setEmail(user.email);
            setCompany_Name(user.company_name);
            loadProducts(user.email, user.company_name);
        } catch (error) {
            console.error("Failed to parse user data:", error);
        }
    }

    const loadProducts = async (userEmail, userCompany) => {
        setLoadingProducts(true);
        setProductError(null);
        try {
            const response = await axios.get('https://backend-livestream-production.up.railway.app/api/get-products', {
                params: {
                    email: userEmail,
                    company_name: userCompany
                }
            });
            
            console.log('API Response:', response.data);
            
            // Handle the response structure from your screenshot
            let productsData = [];
            
            if (response.data && response.data.data && Array.isArray(response.data.data)) {
                productsData = response.data.data;
            }
            
            // Ensure all products have required fields
            productsData = productsData.map(product => ({
                product_name: product.product_name || 'Unnamed Product',
                selling_price: product.selling_price || 0,
                product_description: product.product_description || product.description || 'No description available',
                id: product.id || product._id || Math.random().toString(36).substr(2, 9)
            }));
            
            setProducts(productsData);
            
        } catch (error) {
            console.error('Error loading products:', error);
            setProductError(error.response?.data?.message || 'Failed to load products. Please try again.');
            setProducts([]);
        } finally {
            setLoadingProducts(false);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const validateForm = () => {
        const newErrors = {};
        if (!formData.product_name.trim()) newErrors.product_name = 'Product name is required';
        if (!formData.product_description.trim()) newErrors.product_description = 'Product description is required';
        if (!formData.selling_price || isNaN(formData.selling_price)) {
            newErrors.selling_price = 'Valid selling price is required';
        }
        
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!validateForm()) {
            return;
        }
        
        setIsSubmitting(true);
        try {
            const userData = authStorage.getUser();
            if (!userData) throw new Error('User not authenticated');
            
            const user = JSON.parse(userData);
            
            const response = await axios.post('https://backend-livestream-production.up.railway.app/api/add-products', {
                product_name: formData.product_name,
                selling_price: parseFloat(formData.selling_price),
                description: formData.product_description,
                email: user.email,
                campany_name: user.company_name
            });
            
            console.log('Add Product Response:', response.data);
            
            await loadProducts(user.email, user.company_name);
            
            setSuccessMessage('Product added successfully!');
            setFormData({
                product_name: "",
                selling_price: "",
                product_description: ""
            });
            
            setTimeout(() => setSuccessMessage(''), 3000);
        } catch (error) {
            console.error('Error adding product:', error);
            setErrors({ 
                submit: error.response?.data?.message || 
                       error.response?.data?.error || 
                       'Failed to add product. Please try again.' 
            });
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleContinueToServices = () => {
        navigate('/add-service');
    };

    const filteredProducts = products.filter(product => {
        if (!product) return false;
        
        const searchTermLower = searchTerm.toLowerCase();
        const productName = (product.product_name || '').toLowerCase();
        const productDesc = (product.product_description || product.description || '').toLowerCase();
        
        return productName.includes(searchTermLower) || 
               productDesc.includes(searchTermLower);
    });

    useEffect(() => {
        getUserRegistrationDetails();
    }, []);

    const steps = [
        { id: 1, name: 'Personal Details', path: '#', current: location.pathname === '/add-personal-detail' },
        { id: 2, name: 'Add Products', path: '#', current: location.pathname === '/add-product' },
        { id: 3, name: 'Add Services', path: '#', current: location.pathname === '/add-service' },
    ];

    return (
        <div className="container-fluid" style={{ backgroundColor: '#f8f9fa', minHeight: '100vh' }}>
            {/* Mobile Header */}
            <div className="d-md-none d-flex justify-content-between align-items-center p-3 bg-white shadow-sm">
                <button 
                    className="btn btn-outline-secondary"
                    onClick={() => setSidebarOpen(!sidebarOpen)}
                >
                    <i className="bi bi-list"></i>
                </button>
                <h5 className="mb-0 fw-bold text-center flex-grow-1">Add Product</h5>
                <div style={{ width: '40px' }}></div>
            </div>

            <div className='row g-0'>
                {/* Sidebar */}
                <div 
                    className={`col-md-3 col-lg-2 d-md-block sidebar ${sidebarOpen ? 'd-block' : 'd-none'}`} 
                    style={{ 
                        backgroundColor: '#2c3e50',
                        position: sidebarOpen ? 'fixed' : 'static',
                        zIndex: 1000,
                        height: sidebarOpen ? '100vh' : 'auto',
                        width: sidebarOpen ? '250px' : 'auto'
                    }}
                >
                    <div className="position-sticky pt-4">
                        {sidebarOpen && (
                            <button 
                                className="btn btn-link text-white position-absolute top-0 end-0 m-2"
                                onClick={() => setSidebarOpen(false)}
                            >
                                <i className="bi bi-x-lg"></i>
                            </button>
                        )}
                        <div className="text-center mb-4">
                            <img 
                                src={ProfileAvatar} 
                                alt="Profile" 
                                className="rounded-circle shadow mb-3"
                                style={{ 
                                    width: '90px', 
                                    height: '90px', 
                                    objectFit: 'cover',
                                    border: '3px solid #3498db'
                                }}
                            />
                            <h6 className="fw-bold text-white">{company_name || 'Your Company'}</h6>
                        </div>
                        
                        <nav className="nav flex-column px-3">
                            {steps.map((step) => (
                                <div key={step.id} className="mb-2">
                                    <div 
                                        className={`nav-link d-flex align-items-center ${step.current ? 'active-step' : 'text-white'}`}
                                        style={{ 
                                            cursor: 'pointer',
                                            borderRadius: '8px',
                                            padding: '12px 16px',
                                            fontWeight: '600',
                                            transition: 'all 0.3s ease',
                                            backgroundColor: step.current ? '#3498db' : 'transparent',
                                            marginBottom: '4px'
                                        }}
                                        onClick={() => {
                                            navigate(step.path);
                                            setSidebarOpen(false);
                                        }}
                                    >
                                        <span 
                                            className={`badge me-3 ${step.current ? 'bg-white text-primary' : 'bg-secondary text-white'}`}
                                            style={{ 
                                                width: '28px', 
                                                height: '28px', 
                                                display: 'flex', 
                                                alignItems: 'center', 
                                                justifyContent: 'center',
                                                fontSize: '0.9rem',
                                                fontWeight: 'bold'
                                            }}
                                        >
                                            {step.id}
                                        </span>
                                        <span style={{ fontSize: '0.95rem' }}>{step.name}</span>
                                    </div>
                                    {step.id < steps.length && (
                                        <div className="ms-5" style={{ 
                                            height: '24px', 
                                            borderLeft: '2px solid rgba(255,255,255,0.2)',
                                            marginLeft: '13px'
                                        }}></div>
                                    )}
                                </div>
                            ))}
                        </nav>
                    </div>
                </div>

                {/* Main Content */}
                <div className={`col-md-9 col-lg-10 ${sidebarOpen ? 'd-none d-md-block' : ''}`}>
                    <div className="row g-0">
                        {/* Form Column */}
                        <div className='col-lg-5 col-xl-4 p-3 p-md-4'>
                            <div className="card border-0 shadow w-100" style={{ 
                                borderRadius: '12px',
                                borderTop: '4px solid #3498db'
                            }}>
                                <div className="card-body p-3 p-md-4">
                                    <div className="text-center mb-4">
                                        <h2 className="fw-bold" style={{ color: '#2c3e50' }}>Add Product</h2>
                                        {company_name && (
                                            <p className="text-muted fw-semibold">
                                                <i className="bi bi-building me-2"></i>
                                                {company_name}
                                            </p>
                                        )}
                                    </div>
                                    
                                    {successMessage && (
                                        <div className="alert alert-success mb-4 d-flex align-items-center" style={{ borderRadius: '8px' }}>
                                            <i className="bi bi-check-circle-fill me-2"></i>
                                            {successMessage}
                                        </div>
                                    )}
                                    {errors.submit && (
                                        <div className="alert alert-danger mb-4 d-flex align-items-center" style={{ borderRadius: '8px' }}>
                                            <i className="bi bi-exclamation-triangle-fill me-2"></i>
                                            {errors.submit}
                                        </div>
                                    )}
                                    
                                    <form onSubmit={handleSubmit} className="needs-validation" noValidate>
                                        <div className="mb-3">
                                            <label htmlFor="productName" className="form-label fw-bold" style={{ color: '#2c3e50' }}>
                                                Product Name <span className="text-danger">*</span>
                                            </label>
                                            <input 
                                                type="text" 
                                                className={`form-control ${errors.product_name ? 'is-invalid' : ''}`}
                                                style={{
                                                    padding: '10px',
                                                    borderRadius: '8px',
                                                    border: '2px solid #e0e0e0'
                                                }}
                                                id="productName" 
                                                placeholder="Enter product name" 
                                                name="product_name"
                                                value={formData.product_name}
                                                onChange={handleChange}
                                                required
                                            />
                                            {errors.product_name && (
                                                <div className="invalid-feedback fw-semibold">{errors.product_name}</div>
                                            )}
                                        </div>
                                        
                                        <div className="mb-3">
                                            <label htmlFor="price" className="form-label fw-bold" style={{ color: '#2c3e50' }}>
                                                Selling Price <span className="text-danger">*</span>
                                            </label>
                                            <div className="input-group">
                                                <span className="input-group-text fw-bold" style={{
                                                    border: '2px solid #e0e0e0',
                                                    borderRight: 'none',
                                                    borderTopLeftRadius: '8px',
                                                    borderBottomLeftRadius: '8px'
                                                }}>$</span>
                                                <input 
                                                    type="number" 
                                                    className={`form-control ${errors.selling_price ? 'is-invalid' : ''}`}
                                                    style={{
                                                        padding: '10px',
                                                        border: '2px solid #e0e0e0',
                                                        borderLeft: 'none',
                                                        borderTopRightRadius: '8px',
                                                        borderBottomRightRadius: '8px'
                                                    }}
                                                    id="price" 
                                                    placeholder="0.00" 
                                                    min="0" 
                                                    step="0.01" 
                                                    required 
                                                    name="selling_price"
                                                    value={formData.selling_price}
                                                    onChange={(e) => {
                                                        const value = parseFloat(e.target.value);
                                                        handleChange({
                                                            target: {
                                                                name: e.target.name,
                                                                value: isNaN(value) ? '' : value
                                                            }
                                                        });
                                                    }}
                                                />
                                                {errors.selling_price && (
                                                    <div className="invalid-feedback fw-semibold">{errors.selling_price}</div>
                                                )}
                                            </div>
                                        </div>
                                          
                                        <div className="mb-4">
                                            <label htmlFor="description" className="form-label fw-bold" style={{ color: '#2c3e50' }}>
                                                Description <span className="text-danger">*</span>
                                            </label>
                                            <textarea 
                                                className={`form-control ${errors.product_description ? 'is-invalid' : ''}`}
                                                style={{
                                                    padding: '10px',
                                                    borderRadius: '8px',
                                                    border: '2px solid #e0e0e0',
                                                    minHeight: '100px'
                                                }}
                                                id="description" 
                                                rows="3" 
                                                placeholder="Product details..."
                                                name="product_description"
                                                value={formData.product_description}
                                                onChange={handleChange}
                                                required
                                            ></textarea>
                                            {errors.product_description && (
                                                <div className="invalid-feedback fw-semibold">{errors.product_description}</div>
                                            )}
                                        </div>
                                        
                                        <button 
                                            type="submit" 
                                            className="btn w-100 py-2 py-md-3 fw-bold"
                                            disabled={isSubmitting}
                                            style={{
                                                borderRadius: '8px',
                                                backgroundColor: '#3498db',
                                                border: 'none',
                                                fontSize: '1rem'
                                            }}
                                        >
                                            {isSubmitting ? (
                                                <>
                                                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                    Adding Product...
                                                </>
                                            ) : (
                                                <>
                                                    <i className="bi bi-plus-circle-fill me-2"></i>
                                                    Add Product
                                                </>
                                            )}
                                        </button>
                                    </form>
                                </div>
                            </div>
                        </div>
                        
                        {/* Product List Column */}
                        <div className='col-lg-7 col-xl-8 bg-white p-3 p-md-4'>
                            <div className="d-flex flex-column h-100">
                                <div className="p-3 p-md-4 border-bottom" style={{ backgroundColor: '#f8fafc' }}>
                                    <div className="d-flex flex-column flex-md-row justify-content-between align-items-center">
                                        <h3 className="fw-bold mb-3 mb-md-0" style={{ color: '#2c3e50' }}>
                                            <i className="bi bi-box-seam me-2"></i>
                                            Product Inventory
                                        </h3>
                                        <div className="w-100 w-md-auto">
                                            <div className="input-group">
                                                <input 
                                                    type="text" 
                                                    className="form-control" 
                                                    placeholder="Search products..." 
                                                    style={{
                                                        borderRadius: '8px 0 0 8px',
                                                        border: '2px solid #e0e0e0',
                                                        borderRight: 'none'
                                                    }}
                                                    value={searchTerm}
                                                    onChange={(e) => setSearchTerm(e.target.value)}
                                                />
                                                <button 
                                                    className="btn btn-outline-secondary" 
                                                    type="button"
                                                    style={{
                                                        borderRadius: '0 8px 8px 0',
                                                        border: '2px solid #e0e0e0',
                                                        borderLeft: 'none'
                                                    }}
                                                >
                                                    <i className="bi bi-search"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="p-3 p-md-4 pt-0 flex-grow-1 d-flex flex-column">
                                    <div className="d-flex justify-content-between align-items-center mb-3">
                                        <p className="text-muted mb-0">
                                            Showing {filteredProducts.length} of {products.length} products
                                        </p>
                                    </div>

                                    <div className="flex-grow-1 overflow-auto" style={{ maxHeight: '60vh' }}>
                                        {loadingProducts ? (
                                            <div className="d-flex justify-content-center align-items-center h-100">
                                                <div className="spinner-border text-primary" role="status">
                                                    <span className="visually-hidden">Loading...</span>
                                                </div>
                                            </div>
                                        ) : productError ? (
                                            <div className="alert alert-danger">
                                                <i className="bi bi-exclamation-triangle-fill me-2"></i>
                                                {productError}
                                            </div>
                                        ) : filteredProducts.length > 0 ? (
                                            <div className="row g-3">
                                                {filteredProducts.map((product) => (
                                                    <div key={product.id} className="col-12">
                                                        <div className="card border-0 shadow-sm" style={{ borderRadius: '10px' }}>
                                                            <div className="card-body p-3">
                                                                <div className="d-flex justify-content-between align-items-center">
                                                                    <div>
                                                                        <h5 className="fw-bold mb-1" style={{ color: '#2c3e50', fontSize: '1rem' }}>
                                                                            {product.product_name}
                                                                        </h5>
                                                                        <p className="text-muted mb-2" style={{ fontSize: '0.875rem' }}>
                                                                            {product.product_description}
                                                                        </p>
                                                                        <span className="badge bg-primary fw-semibold" style={{ fontSize: '0.75rem' }}>
                                                                            ${parseFloat(product.selling_price).toFixed(2)}
                                                                        </span>
                                                                    </div>
                                                                    <div>
                                                                        <button 
                                                                            className="btn btn-sm btn-outline-secondary"
                                                                            style={{ borderRadius: '50%', width: '32px', height: '32px' }}
                                                                        >
                                                                            <i className="bi bi-three-dots-vertical"></i>
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        ) : (
                                            <div className="d-flex flex-column justify-content-center align-items-center h-100">
                                                <div className="text-center text-muted py-5">
                                                    <i className="bi bi-box-seam display-4 mb-3" style={{ color: '#e0e0e0' }}></i>
                                                    <h4 className="fw-bold">No products found</h4>
                                                    <p className="mb-0">Add your first product using the form</p>
                                                </div>
                                            </div>
                                        )}
                                    </div>

                                    <div className="mt-4 pt-3 border-top text-center text-md-end">
                                        {products.length >= 2 && (
                                            <button 
                                                type="button" 
                                                className="btn btn-primary px-4 py-2 fw-bold"
                                                onClick={handleContinueToServices}
                                                style={{
                                                    borderRadius: '8px',
                                                    minWidth: '180px'
                                                }}
                                            >
                                                <i className="bi bi-arrow-right-circle-fill me-2"></i>
                                                Continue to Services
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProductAuthAdd;